"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignLeave = assignLeave;
exports.assignReservation = assignReservation;
exports.generateInventory = generateInventory;
exports.hotelLstApi = hotelLstApi;
exports.hotelroomListAllApi = hotelroomListAllApi;
exports.hotelroomLstApi = hotelroomLstApi;
exports.inventoryListAllApi = inventoryListAllApi;
exports.reservationLstApi = reservationLstApi;
exports.reservationLstallApi = reservationLstallApi;
exports.roomCreateApi = roomCreateApi;
exports.roomDeleteApi = roomDeleteApi;
exports.roomDetailApi = roomDetailApi;
exports.roomTypeCreateApi = roomTypeCreateApi;
exports.roomTypeDeleteApi = roomTypeDeleteApi;
exports.roomTypeDetailApi = roomTypeDetailApi;
exports.roomTypeListAllApi = roomTypeListAllApi;
exports.roomTypeOptionsApi = roomTypeOptionsApi;
exports.roomTypeUpdateApi = roomTypeUpdateApi;
exports.roomUpdateApi = roomUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
///////////////////////////////房型///////////////////////////////

/**
 * 新增房型
 * @param pram
 */
function roomTypeCreateApi(data) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room-type/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑房型
 * @param pram
 */
function roomTypeUpdateApi(data) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room-type/update',
    method: 'POST',
    data: data
  });
}

/**
 * 房型详情
 * @param pram
 */
function roomTypeDetailApi(params) {
  return (0, _request.default)({
    url: "/merchant/hotel/hotel-room-type/info",
    method: 'GET',
    params: params
  });
}

/**
 * 删除房型
 * @param pram
 */
function roomTypeDeleteApi(data) {
  return (0, _request.default)({
    url: "/merchant/hotel/hotel-room-type/delete",
    method: 'GET',
    data: data
  });
}

/**
 * 房型列表
 * @param pram
 */
function hotelLstApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room-type/list',
    method: 'GET',
    params: params
  });
}

/**
 * 房型全部列表
 * @param pram
 */
function roomTypeListAllApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room-type/list-all',
    method: 'GET',
    params: params
  });
}
function roomTypeOptionsApi() {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room-type/options',
    method: 'GET'
  });
}
///////////////////////////////房型///////////////////////////////

//////////////////////////////房间///////////////////////////////
/**
 * 新增房间
 * @param pram
 */
function roomCreateApi(data) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑房间
 * @param pram
 */
function roomUpdateApi(data) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room/update',
    method: 'POST',
    data: data
  });
}

/**
 * 房间详情
 * @param pram
 */
function roomDetailApi(data) {
  return (0, _request.default)({
    url: "/merchant/hotel/hotel-room/info",
    method: 'GET',
    data: data
  });
}

/**
 * 删除房间
 * @param pram
 */
function roomDeleteApi(params) {
  return (0, _request.default)({
    url: "/merchant/hotel/hotel-room/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 房间列表
 * @param pram
 */
function hotelroomLstApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room/list',
    method: 'GET',
    params: params
  });
}
function hotelroomListAllApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room/list-all',
    method: 'GET',
    params: params
  });
}
//////////////////////////////房间///////////////////////////////

//////////////////////////////经营相关///////////////////////////////

function assignReservation(data) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room/assign-reservation',
    method: 'POST',
    data: data
  });
}
function assignLeave(data) {
  return (0, _request.default)({
    url: '/merchant/hotel/hotel-room/assign-leave',
    method: 'POST',
    data: data
  });
}
//////////////////////////////经营相关///////////////////////////////

////////////////////////////////库存相关///////////////////////////////
// /generate-inventory

/**
 * 手动生成库存
 * @param {*} data
 * @returns
 */
function generateInventory(params) {
  var id = params.id;
  return (0, _request.default)({
    url: '/merchant/hotel/inventory/generate-inventory?id=' + id,
    method: 'GET'
    // params,
  });
}

/**
 * 每月库存列表
 * @param {} params
 * @returns
 */
function inventoryListAllApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/inventory/list',
    method: 'GET',
    params: params
  });
}
////////////////////////////////库存相关///////////////////////////////

// http://203.110.233.74:20700/api/merchant/hotel/reservation/list
/**
 * 预约列表
 * @param pram
 */
function reservationLstApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/reservation/list',
    method: 'GET',
    params: params
  });
}

/**
 * 营业列表
 * @param pram
 */
function reservationLstallApi(params) {
  return (0, _request.default)({
    url: '/merchant/hotel/reservation/list-all',
    method: 'GET',
    params: params
  });
}